import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash/fp';

import SearchResultListItem from './SearchResultListItem';

import SearchResultsListEmpty from './SearchResultsListEmpty';
import SearchResultsLoading from './SearchResultsLoading';

import './SearchResultsList.scss';

const SearchResultsList = (props) => {
    const { searchResultsList, loading, searchQuery, focusedIndex, ResultComponent } = props;

    if (searchResultsList.length === 0 && !searchQuery) return null;

    if (searchResultsList.length === 0 && !loading && searchQuery) {
        return <SearchResultsListEmpty searchQuery={searchQuery} />;
    }

    return (
        <div className="PopupList SearchResultsList">
            <ul className="popup-list">
                {searchResultsList.map((result, index) => (
                    <SearchResultListItem key={get('id', result) || index} index={index} focusedIndex={focusedIndex}>
                        <ResultComponent {...props} index={index} result={result} />
                    </SearchResultListItem>
                ))}
                {loading && searchQuery && (
                    <li>
                        <SearchResultsLoading />
                    </li>
                )}
            </ul>
        </div>
    );
};

SearchResultsList.propTypes = {
    ResultComponent: PropTypes.elementType.isRequired,
    searchResultsList: PropTypes.array,
    results: PropTypes.object,
    resultsTotal: PropTypes.number,
    loading: PropTypes.bool,
    hasMoreResults: PropTypes.bool,
    searchQuery: PropTypes.string,
    popupMode: PropTypes.string,
    focusedIndex: PropTypes.number,
};

export default SearchResultsList;
